import React from "react";

function FormLabel(props) {
  const requiredMark =
    props.requiredMark !== undefined ? props.requiredMark : true;

  return (
    <div>
      <p className="text-[14px] text-[#626476]">
        {requiredMark ? (
          <span className="text-red-500 text-[12px] font-medium">* </span>
        ) : (
          ""
        )}
        {props.children}
      </p>
    </div>
  );
}

export default FormLabel;
